$(function() {

    $.firefighters = {};

    $.firefighters.delayFadeOut = ($("#firefighters-container").next('section').hasClass('profile-section')) ? false : true;

    $.firefighters.lastProfile = false;

    // durations

    $.firefighters.duration = '75%';

    $.firefighters.calculatePinDuration = function() {
        var contentHeight = $('#firefighters-container .content-container').outerHeight();
        if ($.firefighters.lastProfile) {
            $.firefighters.pinDuration = 0;
        } else {
            $.firefighters.pinDuration = Math.round(contentHeight + $(window).innerHeight());
        }
        return $.firefighters.pinDuration;
	};

    $.firefighters.zoomDuration = '100%';

    $.firefighters.endDuration = ($.firefighters.delayFadeOut) ? '150%' : '50%';

    // timelines

    $.firefighters.tl = {};

    // in

	$.firefighters.tl.in = new TimelineMax();

    $.firefighters.tl.in.addLabel("start");

    $.firefighters.tl.in.set("#firefighters-container", { visibility: "visible" }, "start");﻿

    if (!$.ms) {

        $.firefighters.tl.in.from("#firefighters-svg .line-1", 1, { x:"2560" }, "start");
        $.firefighters.tl.in.from("#firefighters-svg .line-2", 1, { x:"2560", delay: 0.25 }, "start");
        $.firefighters.tl.in.add(function(){ /* pause */ }, "+=0.25");

        new ScrollMagic.Scene({ triggerElement: '#firefighters-in', triggerHook: 'onEnter', duration: $.firefighters.duration })
        	.setTween($.firefighters.tl.in)
        	// .addIndicators({name: 'firefighters in'})
        	.addTo($.controller);

    }

    // pin

    new ScrollMagic.Scene({ triggerElement: '#firefighters-pin', triggerHook: 'onLeave', duration: $.firefighters.pinDuration })
        .setPin('#firefighters-container .svg-background')
        // .addIndicators({name: 'firefighters pin'})
        .addTo($.controller);

    // zoom

    $.firefighters.zoom = {};

    $.firefighters.tl.zoom = new TimelineMax();

    $.firefighters.tl.zoom.addLabel("start");
    $.firefighters.tl.zoom.addLabel("content", 2);

    if ($.ms || ($.windowWidth > $.breakpoint.e3 && $.safari)) { // zoom

        $.firefighters.tl.zoom.to("#firefighters-svg .svg-text", 2, { y:"-320" }, "start");

    } else {

        $.firefighters.zoom.scale = 10;
        $.firefighters.zoom.offset = $.firefighters.zoom.scale * 100 / 2;
        $.firefighters.zoom.xy = "-"+ $.firefighters.zoom.offset +"%";

        $.firefighters.tl.zoom.to("#firefighters-svg .svg-text", 2, { x:$.firefighters.zoom.xy, y:$.firefighters.zoom.xy, scaleX:$.firefighters.zoom.scale, scaleY:$.firefighters.zoom.scale, force3D:true }, "start");

    }

    $.firefighters.tl.zoom.to("#firefighters-container .svg-img-overlay-mask", 0.5, { opacity:0 }, "start");
    $.firefighters.tl.zoom.to("#firefighters-background", 0.5, { backgroundColor:$.color.black, delay:1 }, "start");
    $.firefighters.tl.zoom.fromTo("#firefighters-svg .svg-img .img-default", 0.5, { opacity:0 }, { opacity:1, delay:1.5 }, "start");
    $.firefighters.tl.zoom.set("#firefighters-svg .svg-bg", { visibility:"hidden", delay:2 }, "start");﻿
    $.firefighters.tl.zoom.set("#firefighters-svg .svg-img-mask", { visibility:"hidden", delay:2 }, "start");﻿

    $.firefighters.tl.zoom.fromTo("#firefighters-container .svg-img-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    $.firefighters.tl.zoom.fromTo("#firefighters-container .svg-content-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    if ($.windowWidth > $.breakpoint.lg) {
        $.firefighters.tl.zoom.fromTo("#firefighters-container .svg-content-overlay", 0.5, { x:"-100%" }, { x:"0%" }, "content");
    }
    $.firefighters.tl.zoom.fromTo("#firefighters-container .content-container", 0.5, { opacity:0 }, { opacity:1, delay:0.5 }, "content");

    new ScrollMagic.Scene({ triggerElement: '#firefighters-zoom', triggerHook: 'onCenter', duration: $.firefighters.zoomDuration })
        .on('start', function () {
            $.firefighters.tl.in.seek($.firefighters.tl.in.duration(), false);
        })
        .setTween($.firefighters.tl.zoom)
        // .addIndicators({name: 'firefighters zoom'})
        .addTo($.controller);

    $.firefighters.tl.out = new TimelineMax();

    $.firefighters.tl.out.addLabel("start");

    $.firefighters.tl.out.to("#firefighters-container .content-container", 1, { opacity:0 }, "start");

    if ($.firefighters.delayFadeOut) {
        $.firefighters.tl.out.to("#firefighters-background", 1, { opacity:0, delay:2 }, "start");
    } else {
        $.firefighters.tl.out.to("#firefighters-background", 1, { opacity:0 }, "start");
    }

    new ScrollMagic.Scene({ triggerElement: '#firefighters-end', triggerHook: 'onCenter', duration: $.firefighters.endDuration })
        .setTween($.firefighters.tl.out)
        // .addIndicators({name: 'firefighters out'})
        .addTo($.controller);

});
